import React, { useMemo } from 'react';
import { FuelCallout, FuelDivider } from '@frete.com/fuel-react';
import { ContactInfo, TruckerInformationDescription, TruckerInformationsBenefits } from './parts';
import { IncompleteTruckerProfileProps, MissingTruckerProfileType } from './types';
import { SidebarWrapper, WhatsappContact } from '@/components';

const descriptions: Record<MissingTruckerProfileType, string[]> = {
  noRegistered: [
    'É obrigatório que o motorista esteja cadastrado na Fretebras.',
    'Você pode finalizar o preenchimento do cadastro enquanto aguarda o motorista. Ele terá 24 horas para completar seu cadastro.',
  ],
  noSelfIsValid: [
    'É obrigatório que o motorista atualize a selfie no aplicativo.',
    'Você pode finalizar o preenchimento do cadastro enquanto aguarda a atualização pelo motorista. Ele terá 24 horas para atualizar sua selfie.',
  ],
};

const callouts: Record<MissingTruckerProfileType, string> = {
  noRegistered: 'Motorista não encontrado',
  noSelfIsValid: 'O motorista não possui selfie válida',
};

export const IncompleteTruckerProfile: React.FC<IncompleteTruckerProfileProps> = ({ type, open, cellPhone }) => {
  const showBenefits = useMemo(() => type === 'noRegistered', [type]);

  const content = useMemo(() => {
    if (!type) return null;

    return (
      <>
        <FuelCallout fullWidth color="orange" icon="alert" iconShape message={callouts[type]} />
        <TruckerInformationDescription texts={descriptions[type]} />
        {showBenefits && <TruckerInformationsBenefits />}
        <WhatsappContact cellPhone={cellPhone} type={type} />
        <FuelDivider />
        <ContactInfo />
      </>
    );
  }, [type, cellPhone, showBenefits]);

  return <SidebarWrapper open={open}>{content}</SidebarWrapper>;
};
